var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateSupplyOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6 2.8H0V0H12.6V2.8ZM7 11.2C7 11.69 7.091 12.159 7.245 12.6H0.7V3.5H11.9V7.063C11.669 7.028 11.438 7 11.2 7C8.883 7 7 8.883 7 11.2ZM8.4 7V5.95C8.4 5.754 8.246 5.6 8.05 5.6H4.55C4.354 5.6 4.2 5.754 4.2 5.95V7H8.4ZM11.9 10.5V8.4H10.5V10.5H8.4V11.9H10.5V14H11.9V11.9H14V10.5H11.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSupplyOrderIcon);
export default __webpack_public_path__ + "static/media/create-supply-order-icon.607fcbcaf2ca7fb5d5557ac69b212006.svg";
export { ForwardRef as ReactComponent };